module.exports = __webpack_public_path__ + "img/新能源汽车_01.5d03210d.png";